const product_stocks = {
  permissionSource: 'api::product-stock.product-stock',
  listingTitle: 'Product Stocks',
  creationTitle: 'Create Product Stock',
  creationEndPoint: '/product-stocks',
  detailTitle: 'Product Stock: :product_name',
  detailEndPoint: '/product-stocks/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Product',
          value: 'product',
          tag: 'single-select',
          dataSourceUrl: '/product-stocks/products',
          dataLabel: 'name',
          required: true,
          disabled: true,
        },
        {
          label: 'Remaining Stock',
          value: 'remaining_number',
          tag: 'input',
          type: 'number',
          required: true,
          disabled: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Alarm Stock Number',
          value: 'alarm_number',
          tag: 'input',
          type: 'number',
        },
        {
          label: 'Alarm Target Emails',
          value: 'alarm_target_emails',
          tag: 'input',
          type: 'text',
          validateGroup: ['multiple-emails'],
          placeholder: 'Type multiple email and separate with comma',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Alarm Email Subject',
          value: 'subject',
          tag: 'input',
          type: 'text',
          placeholder: `Out of stock`,
        },
        {
          label: 'Attachments',
          value: 'attachments',
          tag: 'multi-media',
          disabled: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationData: {
    product: ':page_id',
  },
}
export default product_stocks
